import React, { Component } from 'react'

import ConfiguracionHitsBalance from './asignacion-hits/ConfiguracionHitsBalance';

class Preferencias extends Component {

  render() {
    return (
      <div>
        <div className="py-3">
          <strong className="text-brand">MIS HITS</strong>
        </div>

        <div className="row">
          <div className="col">
            <p>
              Por defecto los hits deben ser asignados a tus empresas pero puedes decidir cómo asignarlos, para cambiar el modo de asignación de hits selecciona una opción.
            </p>
          </div>
        </div>

        <ConfiguracionHitsBalance onConfigUpdateSuccess={ this.handleOnConfigUpdateSuccess } />

      </div>
    )
  }
}

export default Preferencias;